const error = {
  error: {
    creationFailed: 'Creation Failed',
    consecutiveWhitespace: 'Consecutive whitespace is not allowed.',
    invalidField: 'Please provide a valid {{field}}.',
    maxCharacters: 'This field must have a maximum of {{max}} characters.',
    maxErrorValue: '{{value}} must be less than {{max}}.',
    minCharacters: 'This field must have a minimum of {{min}} characters.',
    minErrorValue: '{{value}} must be greater than {{min}}.',
    notSuccessfully: 'Sorry, the {{item}} could not be {{what}} successfully.',
    betweenMinMaxErrorValue:
      '{{value}} value must be between "{{min}}" and "{{max}}".',
    passwordDontMatch: `Password and confirm password don't match`,
    pageNotFound: 'Page not found',
    requiredField: 'This field is required.',
    requiredFieldArray:
      'This field is required. Must have at least {{min}} {{field}}',
    regexInput: 'Invalid characters: ~ < > [ ] \\ | * ?',
    regexTextarea: 'The following characters are not allowed: ~<>/\\{|}',
    returnToHomepage: 'Back to the Homepage',
    theRequestPageWasNotFoundOnThisServer:
      'The requested page was not found on this server',
    updateFailed: 'Update Failed',
    duplicateFailed: 'Duplicate Failed',
  },
}

export default error
